var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.932 6.2565C16.6013 5.92581 16.0671 5.92581 15.7364 6.2565L11.59 10.3944L7.44361 6.24802C7.11291 5.91733 6.57871 5.91733 6.24802 6.24802C5.91733 6.57871 5.91733 7.11291 6.24802 7.44361L10.3944 11.59L6.24802 15.7364C5.91733 16.0671 5.91733 16.6013 6.24802 16.932C6.57871 17.2627 7.11291 17.2627 7.44361 16.932L11.59 12.7856L15.7364 16.932C16.0671 17.2627 16.6013 17.2627 16.932 16.932C17.2627 16.6013 17.2627 16.0671 16.932 15.7364L12.7856 11.59L16.932 7.44361C17.2542 7.12139 17.2542 6.57871 16.932 6.2565Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close_black.8e5a5eadd6009b2fa6e747f44861aa2c.svg";
export { ForwardRef as ReactComponent };